var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AdminSettingsPage"},[_c('DashboardSectionHeader',{attrs:{"title":"Settings"}}),_c('OwnerForm'),_c('CompanyForm',{attrs:{"company":_vm.company}}),_c('SubscriptionView')],1)}
var staticRenderFns = []

export { render, staticRenderFns }